import "./style.scss";

jQuery(document).ready(function ($) {
  let tlgbAllTimeline = $(".wp-block-tlgb-b-timeline-block");

  Object.values(tlgbAllTimeline).map((timeline) => {
    const timelineData = $(`#${timeline.id}`).data("timeline");
    if (!timelineData) return false;

    const {
      type,
      labelLocation,
      startIndex,
      moveItem,
      visibleItems,
      verticalTrigger,
      rtlMode,
    } = timelineData;

    $(`#${timeline.id} .timeline`).timeline({
      mode: type || "vertical",
      verticalStartPosition: labelLocation,
      horizontalStartPosition: labelLocation,
      forceVerticalMode: 600,
      verticalTrigger: `'${verticalTrigger}'`,
      moveItems: moveItem,
      startIndex,
      visibleItems,
      rtlMode,
    });

    $(timelineData).removeAttr("data-timeline");
  });
});
